(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6023,9600],{

/***/ 48824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ startups; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation2/index.ts + 91 modules
var Navigation2 = __webpack_require__(92609);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/templates/Testimonial/index.ts + 2 modules
var templates_Testimonial = __webpack_require__(5099);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Industry/StartupsPage/components/Testimonial/Testimonial.tsx






var copy = {
  heading: "Analytics is crucial for product market fit"
};

var Testimonial = function Testimonial() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBase, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          children: copy.heading
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(templates_Testimonial/* default */.Z, {
        company: "y-combinator"
      })
    })]
  });
};

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1kxwm2o0"
} : 0)("max-width:1060px;", Section/* Wrapper */.im, "{row-gap:40px;}" + ( true ? "" : 0));

/* harmony default export */ var Testimonial_Testimonial = (Testimonial);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/tracking/scripts/index.ts + 2 modules
var scripts = __webpack_require__(17397);
// EXTERNAL MODULE: ../../libs/utils/useStartupLinks/index.ts + 1 modules
var useStartupLinks = __webpack_require__(94932);
// EXTERNAL MODULE: ./src/views/Industry/StartupsPage/components/Hero/assets/HeroIndustryStartups@2x.png
var HeroIndustryStartups_2x = __webpack_require__(67399);
var HeroIndustryStartups_2x_default = /*#__PURE__*/__webpack_require__.n(HeroIndustryStartups_2x);
// EXTERNAL MODULE: ./src/views/Industry/StartupsPage/components/Hero/assets/HeroIndustryStartups.webp
var HeroIndustryStartups = __webpack_require__(52766);
var HeroIndustryStartups_default = /*#__PURE__*/__webpack_require__.n(HeroIndustryStartups);
// EXTERNAL MODULE: ./src/views/Industry/StartupsPage/components/Hero/assets/HeroIndustryStartups@2x.webp
var assets_HeroIndustryStartups_2x = __webpack_require__(27573);
var assets_HeroIndustryStartups_2x_default = /*#__PURE__*/__webpack_require__.n(assets_HeroIndustryStartups_2x);
// EXTERNAL MODULE: ./src/views/Industry/StartupsPage/components/Hero/assets/HeroIndustryStartups@3x.webp
var HeroIndustryStartups_3x = __webpack_require__(78682);
var HeroIndustryStartups_3x_default = /*#__PURE__*/__webpack_require__.n(HeroIndustryStartups_3x);
;// CONCATENATED MODULE: ./src/views/Industry/StartupsPage/components/Hero/Hero.tsx














var Hero_copy = {
  heading: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: "The ultimate analytics setup is\xA0now free"
  }),
  description: "Collecting and analyzing customer data is critical to finding product-market fit. That\u2019s why we\u2019re giving early-stage startups Segment for free for up to two years when you join our Startup Program\u2014along with other perks."
};
var Hero_link = {
  text: "Apply now"
};

var Hero = function Hero() {
  var _useStartupLinks = (0,useStartupLinks/* default */.ZP)(),
      applyLink = _useStartupLinks.applyLink;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* default */.ZP, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h1",
            tag: "h1",
            children: Hero_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pExtraLarge",
            tag: "p",
            children: Hero_copy.description
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Form */.l0, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
            tag: "a",
            href: applyLink,
            onClick: function onClick() {
              return (0,scripts/* trackButtonClick */.kO)({
                buttonText: Hero_link.text,
                targetUrl: applyLink
              });
            },
            iconEnd: Common/* ChevronRightIcon */.XC,
            children: Hero_link.text
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Picture, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
            type: "image/webp",
            srcSet: "".concat((HeroIndustryStartups_default()), ", ").concat((assets_HeroIndustryStartups_2x_default()), " 2x, ").concat((HeroIndustryStartups_3x_default()), " 3x")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Image */.Ee, {
            width: "626",
            height: "404",
            src: (HeroIndustryStartups_2x_default()),
            alt: "Illustration: Industry Startups Hero"
          })]
        })
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "eq00cpe1"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "eq00cpe0"
} : 0)("filter:drop-shadow(", function (_ref2) {
  var theme = _ref2.theme;
  return theme.shadows[2];
}, ");" + ( true ? "" : 0));

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/Industry/StartupsPage/components/OneApi/assets/OneApi@2x.png
var OneApi_2x = __webpack_require__(19088);
var OneApi_2x_default = /*#__PURE__*/__webpack_require__.n(OneApi_2x);
// EXTERNAL MODULE: ./src/views/Industry/StartupsPage/components/OneApi/assets/OneApi.webp
var OneApi = __webpack_require__(47358);
var OneApi_default = /*#__PURE__*/__webpack_require__.n(OneApi);
// EXTERNAL MODULE: ./src/views/Industry/StartupsPage/components/OneApi/assets/OneApi@2x.webp
var assets_OneApi_2x = __webpack_require__(65273);
var assets_OneApi_2x_default = /*#__PURE__*/__webpack_require__.n(assets_OneApi_2x);
// EXTERNAL MODULE: ./src/views/Industry/StartupsPage/components/OneApi/assets/OneApi@3x.webp
var OneApi_3x = __webpack_require__(97267);
var OneApi_3x_default = /*#__PURE__*/__webpack_require__.n(OneApi_3x);
;// CONCATENATED MODULE: ./src/views/Industry/StartupsPage/components/OneApi/OneApiImage.tsx









var OneApiImage = function OneApiImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OneApiImage_Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((OneApi_default()), ", ").concat((assets_OneApi_2x_default()), " 2x, ").concat((OneApi_3x_default()), " 3x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "481",
      src: (OneApi_2x_default()),
      alt: "Illustration: One Api Cleaner Code",
      loading: "lazy"
    })]
  });
};

var OneApiImage_Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "egiuin30"
} : 0)("filter:drop-shadow(", function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[2];
}, ");" + ( true ? "" : 0));

/* harmony default export */ var OneApi_OneApiImage = (OneApiImage);
;// CONCATENATED MODULE: ./src/views/Industry/StartupsPage/components/OneApi/OneApi.tsx





var OneApi_copy = {
  heading: "One API. Cleaner code.",
  description: "Our analytics API makes collecting data simple. Reduce all of your tracking code and advertising tags into a single API."
};

var OneApi_OneApi = function OneApi() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    copyVariant: "narrow",
    reverse: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          children: OneApi_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          children: OneApi_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OneApi_OneApiImage, {})
    })]
  });
};

/* harmony default export */ var components_OneApi_OneApi = (OneApi_OneApi);
// EXTERNAL MODULE: ./src/views/Industry/StartupsPage/components/LetEngineersFocused/assets/LetEngineersFocused@2x.png
var LetEngineersFocused_2x = __webpack_require__(10345);
var LetEngineersFocused_2x_default = /*#__PURE__*/__webpack_require__.n(LetEngineersFocused_2x);
// EXTERNAL MODULE: ./src/views/Industry/StartupsPage/components/LetEngineersFocused/assets/LetEngineersFocused.webp
var LetEngineersFocused = __webpack_require__(30149);
var LetEngineersFocused_default = /*#__PURE__*/__webpack_require__.n(LetEngineersFocused);
// EXTERNAL MODULE: ./src/views/Industry/StartupsPage/components/LetEngineersFocused/assets/LetEngineersFocused@2x.webp
var assets_LetEngineersFocused_2x = __webpack_require__(48702);
var assets_LetEngineersFocused_2x_default = /*#__PURE__*/__webpack_require__.n(assets_LetEngineersFocused_2x);
// EXTERNAL MODULE: ./src/views/Industry/StartupsPage/components/LetEngineersFocused/assets/LetEngineersFocused@3x.webp
var LetEngineersFocused_3x = __webpack_require__(61950);
var LetEngineersFocused_3x_default = /*#__PURE__*/__webpack_require__.n(LetEngineersFocused_3x);
;// CONCATENATED MODULE: ./src/views/Industry/StartupsPage/components/LetEngineersFocused/LetEngineersFocusedImage.tsx









var LetEngineersFocusedImage = function LetEngineersFocusedImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LetEngineersFocusedImage_Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((LetEngineersFocused_default()), ", ").concat((assets_LetEngineersFocused_2x_default()), " 2x, ").concat((LetEngineersFocused_3x_default()), " 3x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "616",
      height: "488",
      src: (LetEngineersFocused_2x_default()),
      alt: "Illustration: Let Engineers Focused on Product",
      loading: "lazy"
    })]
  });
};

var LetEngineersFocusedImage_Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "e1a9ahtu0"
} : 0)("filter:drop-shadow(", function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[2];
}, ");" + ( true ? "" : 0));

/* harmony default export */ var LetEngineersFocused_LetEngineersFocusedImage = (LetEngineersFocusedImage);
;// CONCATENATED MODULE: ./src/views/Industry/StartupsPage/components/LetEngineersFocused/LetEngineersFocused.tsx






var LetEngineersFocused_copy = {
  heading: "Let your engineers focus on product, not integrations",
  description: "Building and maintaining integrations take a lot of developer time. Segment makes it easy. Instrument your analytics once, and integrate with ".concat("450", "+ tools in just a few minutes.")
};

var StreamlineYourRegulatoryCompliance = function StreamlineYourRegulatoryCompliance() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionCopy, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          children: LetEngineersFocused_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          children: LetEngineersFocused_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LetEngineersFocused_LetEngineersFocusedImage, {})
    })]
  });
};

var SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e1rmanfn0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;justify-self:end;align-self:center;}" + ( true ? "" : 0));

/* harmony default export */ var LetEngineersFocused_LetEngineersFocused = (StreamlineYourRegulatoryCompliance);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/components/IconWrapper/index.ts + 2 modules
var IconWrapper = __webpack_require__(79600);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Brandbook.ts + 92 modules
var Brandbook = __webpack_require__(79550);
;// CONCATENATED MODULE: ./src/views/Industry/StartupsPage/components/SegmentCredits/data.tsx


var cards = function cards(color) {
  return [{
    key: "Segment-credits",
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* DollarIcon */.te, {
      color: color
    }),
    title: "Segment credits",
    description: "Eligible startups get full access to our team plan (up to $25,000 value) free for up to two years."
  }, {
    key: "$1M-in-free-software",
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* ToolIcon */.Ec, {
      color: color
    }),
    title: "$1M in free software",
    description: "We\u2019ve partnered with marketing and analytics companies like Amplitude, AWS, and Intercom to offer sweet deals on the tools startups need most."
  }, {
    key: "Startup-resources",
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* BusinessIcon */.wZ, {
      color: color
    }),
    title: "Startup resources",
    description: "We\u2019ve designed resources to help you level up your data and analytics like Analytics Office Hours and Analytics Academy."
  }, {
    key: "Eligibility-requirements",
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* CheckIcon */.nQ, {
      color: color
    }),
    title: "Eligibility requirements",
    description: "Incorporated less than 2 years ago + raised no more than $5MM in total funding."
  }];
};
;// CONCATENATED MODULE: ./src/views/Industry/StartupsPage/components/SegmentCredits/SegmentCredits.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var SegmentCredits_copy = {
  title: "Get $25,000 in Segment credits"
};
var SegmentCredits_button = {
  text: "Apply now"
};

var SegmentCredits = function SegmentCredits() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _useStartupLinks = (0,useStartupLinks/* default */.ZP)(),
      applyLink = _useStartupLinks.applyLink;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentCredits_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
          centered: true,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h3",
            children: SegmentCredits_copy.title
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Body, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
            columns: 1,
            overrides: {
              md: 2,
              lg: 4
            },
            children: cards(theme.palette.twilio.gray[100]).map(function (card) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* default */.ZP, {
                headerPosition: "top",
                alignment: "left",
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Header */.h4, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper/* default */.Z, {
                    variant: "circle",
                    elevation: 1,
                    children: card.icon
                  })
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                    variant: "h5",
                    tag: "h4",
                    children: card.title
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                    variant: "pMedium",
                    tag: "div",
                    children: card.description
                  })]
                })]
              }, card.key);
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
              tag: "a",
              href: applyLink,
              onClick: function onClick() {
                return (0,scripts/* trackButtonClick */.kO)({
                  buttonText: SegmentCredits_button.text,
                  targetUrl: applyLink
                });
              },
              iconEnd: Common/* ChevronRightIcon */.XC,
              children: SegmentCredits_button.text
            })
          })]
        })
      })]
    })
  });
};

var SegmentCredits_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11gmpk12"
} : 0)( true ? "" : 0);

var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11gmpk11"
} : 0)( true ? {
  name: "1rqlo2l",
  styles: "padding-top:60px;text-align:center"
} : 0);

var Body = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11gmpk10"
} : 0)( true ? {
  name: "xw24us",
  styles: "max-width:1120px;margin:0 auto"
} : 0);

/* harmony default export */ var SegmentCredits_SegmentCredits = (SegmentCredits);
;// CONCATENATED MODULE: ./src/views/Industry/StartupsPage/components/WantDoubleSegmentCredits/WantDoubleSegmentCredits.tsx


function WantDoubleSegmentCredits_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var WantDoubleSegmentCredits_copy = {
  title: "Want double the Segment credits?"
};
var descriptionLink = {
  text: "Check out our FAQ",
  url: "https://segment.com/docs/guides/usage-and-billing/startup-program/"
};

var description = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
  children: ["Send this page to your investor or accelerator where they can apply to be a partner. Have more questions?", " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
    href: descriptionLink.url,
    children: descriptionLink.text
  }), "."]
});

var WantDoubleSegmentCredits = function WantDoubleSegmentCredits() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WantDoubleSegmentCredits_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSection, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCopyTextBase, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h4",
            tag: "h2",
            children: WantDoubleSegmentCredits_copy.title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pMedium",
            children: description
          })]
        })
      })
    })
  });
};

var WantDoubleSegmentCredits_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1mqap182"
} : 0)( true ? "" : 0);

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1mqap181"
} : 0)(Section/* Wrapper */.im, "{padding-top:40px;row-gap:24px;}" + ( true ? "" : 0));

var StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "e1mqap180"
} : 0)( true ? {
  name: "837xmr",
  styles: "max-width:684px"
} : 0);

/* harmony default export */ var WantDoubleSegmentCredits_WantDoubleSegmentCredits = (WantDoubleSegmentCredits);
// EXTERNAL MODULE: ../../libs/templates/TestimonialSlider/index.ts + 11 modules
var TestimonialSlider = __webpack_require__(88302);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/CompanyMono.ts + 229 modules
var CompanyMono = __webpack_require__(71385);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/Company.ts + 237 modules
var Company = __webpack_require__(97079);
;// CONCATENATED MODULE: ./src/views/Industry/StartupsPage/components/ThousandsTrustSegment/data.tsx





var customerData = function customerData() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return [{
    company: "frame-io",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* FrameIoMonoLogo */.QzL, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* FrameIoLogo */.Ltd, {}),
    logoName: "FrameIo"
  }, {
    company: "earnest",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* EarnestMonoLogo */.Iei, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* EarnestLogo */.LjI, {}),
    logoName: "Earnest"
  }, {
    company: "retool",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* RetoolMonoLogo */.U8Y, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* RetoolLogo */.wnT, {}),
    logoName: "Retool"
  }];
};


;// CONCATENATED MODULE: ./src/views/Industry/StartupsPage/components/ThousandsTrustSegment/ThousandsTrustSegment.tsx


function ThousandsTrustSegment_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var ThousandsTrustSegment_copy = {
  heading: "Thousands of startups trust Segment",
  description: "Startups, from early-stage to unicorn, use Segment as their single hub to collect, manage and route analytics data. Learn more in our startup stories."
};

var ThousandsTrustSegment = function ThousandsTrustSegment() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ThousandsTrustSegment_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ThousandsTrustSegment_StyledSection, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h2",
            children: ThousandsTrustSegment_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            children: ThousandsTrustSegment_copy.description
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TestimonialSlider["default"], {
          data: customerData,
          title: false,
          innerStyles: false
        })
      })]
    })
  });
};

var ThousandsTrustSegment_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1h98hud1"
} : 0)( true ? "" : 0);

var ThousandsTrustSegment_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1h98hud0"
} : 0)( true ? {
  name: "etts4h",
  styles: "max-width:1260px;overflow-x:visible"
} : 0);

/* harmony default export */ var ThousandsTrustSegment_ThousandsTrustSegment = (ThousandsTrustSegment);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
;// CONCATENATED MODULE: ./src/views/Industry/StartupsPage/components/SignUp/SignUp.tsx


function SignUp_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var SignUp_copy = {
  heading: "Join the Segment Startup Program to access our full deal book"
};
var SignUp_button = {
  text: "Apply now"
};

var SignUp = function SignUp() {
  var _useStartupLinks = (0,useStartupLinks/* default */.ZP)(),
      applyLink = _useStartupLinks.applyLink;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SignUp_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SignUp_StyledSectionBase, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
        variant: "h2",
        children: SignUp_copy.heading
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
        color: "primary",
        variant: "filled",
        size: "large",
        href: applyLink,
        onClick: function onClick() {
          return (0,scripts/* trackButtonClick */.kO)({
            buttonText: SignUp_button.text,
            targetUrl: applyLink
          });
        },
        children: SignUp_button.text
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  });
};

var SignUp_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1nrqj0r2"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1nrqj0r1"
} : 0)( true ? {
  name: "11ltaps",
  styles: "text-align:center;max-width:684px;margin:0"
} : 0);

var SignUp_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1nrqj0r0"
} : 0)(Section/* Wrapper */.im, "{padding-top:80px;row-gap:40px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding-top:160px;}}" + ( true ? "" : 0));

/* harmony default export */ var SignUp_SignUp = (SignUp);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var Card = __webpack_require__(74881);
;// CONCATENATED MODULE: ./src/views/Industry/StartupsPage/components/LearnHowAnalytics/LearnHowAnalytics.tsx


function LearnHowAnalytics_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var LearnHowAnalytics_copy = {
  heading: "Learn how analytics can accelerate your startup",
  description: "Get started with analytics the right way. Learn how to quantify product-market fit, design your first funnel, tracking plan, metrics, and build a data-driven company."
};

var LearnHowAnalytics = function LearnHowAnalytics(_ref) {
  var cards = _ref.cards;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LearnHowAnalytics_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LearnHowAnalytics_StyledSection, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h2",
            children: LearnHowAnalytics_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            children: LearnHowAnalytics_copy.description
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumnTrack, {
          columns: 1,
          overrides: {
            md: 2
          },
          children: cards.map(function (card) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.ZP, {
              href: card.url,
              "data-dynamic-link": "true",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Headline */.s0, {
                    children: card.title
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
                    variant: "pLarge",
                    children: card.description
                  })]
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
                  alignment: "right",
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronRightIcon */.XC, {})
                })]
              })
            }, card.key);
          })
        })
      })]
    })
  });
};

var LearnHowAnalytics_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1r34c752"
} : 0)( true ? {
  name: "3orjz",
  styles: "max-width:1280px;margin:0 auto"
} : 0);

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "e1r34c751"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("sm");
}, "{margin-bottom:40px;}" + ( true ? "" : 0));

var LearnHowAnalytics_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1r34c750"
} : 0)(Section/* Wrapper */.im, "{padding-top:40px;}" + ( true ? "" : 0));

/* harmony default export */ var LearnHowAnalytics_LearnHowAnalytics = (LearnHowAnalytics);
// EXTERNAL MODULE: ../../libs/matcha/components/VideoPlayer/index.ts + 2 modules
var VideoPlayer = __webpack_require__(41926);
// EXTERNAL MODULE: ../../libs/matcha/components/Elevation/index.ts + 2 modules
var Elevation = __webpack_require__(33606);
// EXTERNAL MODULE: ./src/views/Industry/StartupsPage/components/AnalyticsForStartups/assets/Cover.png
var Cover = __webpack_require__(37135);
var Cover_default = /*#__PURE__*/__webpack_require__.n(Cover);
;// CONCATENATED MODULE: ./src/views/Industry/StartupsPage/components/AnalyticsForStartups/AnalyticsForStartups.tsx


function AnalyticsForStartups_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var AnalyticsForStartups = function AnalyticsForStartups() {
  var _useState = (0,react.useState)(false),
      playing = _useState[0],
      setPlaying = _useState[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnalyticsForStartups_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnalyticsForStartups_StyledSection, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Elevation/* default */.Z, {
          elevation: 7,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VideoPlayer/* default */.ZP, {
            url: "https://www.youtube.com/watch?v=Yf42zrdLQfY",
            playing: playing,
            onEnded: function onEnded() {
              return setPlaying(false);
            },
            onPause: function onPause() {
              return setPlaying(false);
            },
            onPlay: function onPlay() {
              return setPlaying(true);
            },
            children: [!playing && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayer/* BigPlayButton */.sT, {
              ariaLabel: "Play \"Analytics for Startups\" Video",
              onClick: function onClick() {
                return setPlaying(true);
              }
            }, "play-btn"), !playing && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayer/* Cover */.Y9, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AnalyticsForStartups_Picture, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
                  type: "image/webp",
                  srcSet: (Cover_default())
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, {
                  width: "800",
                  height: "455",
                  src: (Cover_default()),
                  alt: "Illustration: Cover",
                  loading: "lazy"
                })]
              })
            }, "cover")]
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Caption, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            tag: "h4",
            children: "Analytics for startups:"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h4",
            tag: "p",
            children: "From AWS Loft, by Ilya Volodarsky, Founder at Segment"
          })]
        })]
      })
    })
  });
};

var AnalyticsForStartups_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "efdjkml4"
} : 0)( true ? {
  name: "qkjop5",
  styles: "max-width:963px;margin:0 auto"
} : 0);

var AnalyticsForStartups_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "efdjkml3"
} : 0)(Section/* Wrapper */.im, "{padding-top:40px;}" + ( true ? "" : 0));

var AnalyticsForStartups_Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "efdjkml2"
} : 0)( true ? {
  name: "9th5i",
  styles: "margin:0 auto"
} : 0);

var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "efdjkml1"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.brand.darkAcai["600"];
}, ";display:block;width:105%;height:auto;" + ( true ? "" : 0));

var Caption = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "efdjkml0"
} : 0)( true ? {
  name: "1memgvi",
  styles: "padding-top:40px;text-align:center;h4,p{margin-top:0;margin-bottom:16px;}"
} : 0);

/* harmony default export */ var AnalyticsForStartups_AnalyticsForStartups = (AnalyticsForStartups);
// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var Badge = __webpack_require__(16154);
// EXTERNAL MODULE: ../../libs/matcha/components/Media/index.ts + 2 modules
var Media = __webpack_require__(75091);
// EXTERNAL MODULE: ../../libs/utils/contentfulImageLoader/contentfulImageLoader.ts
var contentfulImageLoader = __webpack_require__(1959);
;// CONCATENATED MODULE: ./src/views/Industry/StartupsPage/components/GetExclusiveDeals/GetExclusiveDeals.tsx


function GetExclusiveDeals_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
















var GetExclusiveDeals_copy = {
  heading: "Get exclusive deals on your favorite tools",
  description: "Focus on building your product. We\u2019ll get you a sweet discount on all of the best marketing and analytics tools that work with Segment."
};
var GetExclusiveDeals_descriptionLink = {
  text: "Submit a deal",
  url: "https://airtable.com/shr84MIvVo4k8xbaO"
};

var captionDescription = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
  children: ["Want to offer your product to thousands of startups?", " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
    href: GetExclusiveDeals_descriptionLink.url,
    children: GetExclusiveDeals_descriptionLink.text
  }), "."]
});

var GetExclusiveDeals = function GetExclusiveDeals(_ref) {
  var deals = _ref.deals;

  var _useState = (0,react.useState)(false),
      seeMore = _useState[0],
      setSeeMore = _useState[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GetExclusiveDeals_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GetExclusiveDeals_StyledSection, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h2",
            children: GetExclusiveDeals_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            children: GetExclusiveDeals_copy.description
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GetExclusiveDeals_Body, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
            columns: 1,
            overrides: {
              sm: 2,
              md: 3
            },
            children: deals.map(function (card) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.ZP, {
                tag: "div",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Accessories */.v8, {
                    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* AccessoriesRow */.OW, {
                      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo, {
                        loader: function loader() {
                          return (0,contentfulImageLoader/* default */.Z)({
                            src: card.logo,
                            width: Number(card.logoDimensions.width)
                          });
                        },
                        width: card.logoDimensions.width,
                        height: card.logoDimensions.height,
                        src: card.logo,
                        alt: card.title
                      })
                    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* AccessoriesRow */.OW, {
                      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
                        tag: "div",
                        variant: "filledGreen",
                        children: card.badge
                      })
                    })]
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Copy */.CK, {
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
                      children: card.description
                    })
                  })]
                })
              }, card.key);
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
            lessThan: "lg",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShowMore, {
              seeMore: seeMore,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
                tag: "a",
                onClick: function onClick() {
                  return setSeeMore(true);
                },
                iconEnd: Common/* ChevronRightIcon */.XC,
                children: "See more deals"
              })
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GetExclusiveDeals_Caption, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
            variant: "pMedium",
            tag: "p",
            children: captionDescription
          })
        })]
      })]
    })
  });
};

var Logo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e15d5qdf6"
} : 0)( true ? {
  name: "djxnjy",
  styles: "object-fit:contain;width:auto;max-height:32px;margin:0"
} : 0);

var GetExclusiveDeals_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e15d5qdf5"
} : 0)( true ? {
  name: "3orjz",
  styles: "max-width:1280px;margin:0 auto"
} : 0);

var GetExclusiveDeals_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e15d5qdf4"
} : 0)(Section/* Wrapper */.im, "{padding-top:40px;}" + ( true ? "" : 0));

var GetExclusiveDeals_Body = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e15d5qdf3"
} : 0)( true ? {
  name: "15wja6p",
  styles: "max-width:1020px;padding-bottom:80px;margin:0 auto"
} : 0);

var GetExclusiveDeals_Caption = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e15d5qdf2"
} : 0)( true ? {
  name: "zx1ly2",
  styles: "padding-top:20px;text-align:center;p{margin:0;}"
} : 0);

var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e15d5qdf1"
} : 0)("color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.brand.darkAcai["500"];
}, ";" + ( true ? "" : 0));

var ShowMore = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e15d5qdf0"
} : 0)("margin:0 auto;padding-top:80px;width:100%;text-align:center;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("md");
}, "{display:", function (_ref4) {
  var seeMore = _ref4.seeMore;
  return seeMore ? "none" : "block";
}, ";}" + ( true ? "" : 0));

/* harmony default export */ var GetExclusiveDeals_GetExclusiveDeals = (GetExclusiveDeals);
// EXTERNAL MODULE: ./src/views/Industry/StartupsPage/assets/OgIndustryStartups.png
var OgIndustryStartups = __webpack_require__(71494);
var OgIndustryStartups_default = /*#__PURE__*/__webpack_require__.n(OgIndustryStartups);
;// CONCATENATED MODULE: ./src/views/Industry/StartupsPage/IndustryStartups.tsx





















var IndustryStartupsView = function IndustryStartupsView(_ref) {
  var data = _ref.data;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Twilio Segment Startup Program | Twilio Segment ",
      pageDescription: "Twilio Segment is an API-first analytics solution that empowers 20k+ startups to scale their data infrastructure. Collect, clean & act on your customer data.",
      pageOG: (OgIndustryStartups_default()),
      themeColor: theme.palette.brand.darkAcai[700],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation2/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial_Testimonial, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LetEngineersFocused_LetEngineersFocused, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_OneApi_OneApi, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentCredits_SegmentCredits, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WantDoubleSegmentCredits_WantDoubleSegmentCredits, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ThousandsTrustSegment_ThousandsTrustSegment, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LearnHowAnalytics_LearnHowAnalytics, {
          cards: data.cards
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnalyticsForStartups_AnalyticsForStartups, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GetExclusiveDeals_GetExclusiveDeals, {
          deals: data.deals
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignUp_SignUp, {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "ewb1kz90"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var IndustryStartups = (IndustryStartupsView);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var contexts_staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ./src/pages/industry/startups.tsx





var Startups = function Startups(_ref) {
  var data = _ref.data;
  var staticSiteBackend = (0,react.useMemo)(function () {
    return (0,contexts_staticSiteBackend/* createStaticSiteBackend */.I4)();
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contexts_staticSiteBackend/* StaticSiteBackendProvider */.D1, {
    value: staticSiteBackend,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IndustryStartups, {
      data: data
    })
  });
};

var __N_SSG = true;
/* harmony default export */ var startups = (Startups);

/***/ }),

/***/ 39896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ createClient; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ../../libs/utils/retry/retry.ts



var wait = function wait(waitTime) {
  return new Promise(function (resolve) {
    setTimeout(resolve, waitTime);
  });
};

var numberSuffixes = ["st", "nd", "rd"];

var functionFailedText = function functionFailedText(iteration) {
  var _numberSuffixes$itera;

  return "Function failed. Retrying ".concat(iteration + 1).concat((_numberSuffixes$itera = numberSuffixes[iteration]) !== null && _numberSuffixes$itera !== void 0 ? _numberSuffixes$itera : "th", " time...");
};

var allRetriesFailedText = function allRetriesFailedText(retriesCount, errors) {
  return "Function failed too many times. Tired ".concat(retriesCount, " time").concat(retriesCount > 1 ? "s" : "", ".\nThrown errors:\n").concat(errors.map(function (e) {
    return e.toString();
  }).join("\n\n"), "\n");
};
/* eslint-disable no-await-in-loop */

/**
 * Retry function call
 * @param fn - The function to be called
 * @param options - The options object
 * @param options.times - Total amount of function calls. First function call is included.
 * @param options.waitTime - Wait time between retries in milliseconds
 * @returns The function with retries
 */


var retry = function retry(fn, _ref) {
  var times = _ref.times,
      waitTime = _ref.waitTime;
  return /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var errors,
        i,
        _args = arguments;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            errors = [];
            i = 0;

          case 2:
            if (!(i < times)) {
              _context.next = 19;
              break;
            }

            _context.prev = 3;
            _context.next = 6;
            return fn.apply(void 0, _args);

          case 6:
            return _context.abrupt("return", _context.sent);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            console.log(functionFailedText(i));

            if (!(i + 1 < times)) {
              _context.next = 15;
              break;
            }

            _context.next = 15;
            return wait(waitTime);

          case 15:
            errors.push(_context.t0);

          case 16:
            i++;
            _context.next = 2;
            break;

          case 19:
            throw new Error(allRetriesFailedText(times, errors));

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 9]]);
  }));
};
/* eslint-enable no-await-in-loop */


/* harmony default export */ var retry_retry = (retry);
;// CONCATENATED MODULE: ../../libs/utils/retry/index.ts

;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/client.ts
/* provided dependency */ var process = __webpack_require__(34406);



var OMIT_CACHE_PARAMETER = "omitCache";
var CONTENT_PREVIEW_PARAMETER = "contentPreview";

var isCacheDisabled = function isCacheDisabled() {
  return process.env.CI;
};

var createClient = function createClient() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$retry = _ref.retry,
      retryOptions = _ref$retry === void 0 ? {
    times: 3,
    waitTime: 1000
  } : _ref$retry;

  function get(_x, _x2) {
    return _get.apply(this, arguments);
  }

  function _get() {
    _get = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(url, options) {
      var fullUserUrl, fullUrl, isOmitCacheParamMissing, startTime, response, json, endTime, requestTime;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!url.startsWith("/")) {
                _context.next = 20;
                break;
              }

              fullUserUrl = "".concat("https://segment.com/backend").concat(url);
              fullUrl = new URL(fullUserUrl);
              isOmitCacheParamMissing = !fullUrl.searchParams.has(OMIT_CACHE_PARAMETER);

              if (isOmitCacheParamMissing && isCacheDisabled()) {
                fullUrl.searchParams.append(OMIT_CACHE_PARAMETER, "");
              }

              if (process.env.IS_CONTENTFUL_PREVIEW_BRANCH === "true") {
                fullUrl.searchParams.append(CONTENT_PREVIEW_PARAMETER, "true");
              }

              startTime = Date.now();
              _context.next = 9;
              return fetch(fullUrl.toString(), options);

            case 9:
              response = _context.sent;

              if (!response.ok) {
                _context.next = 17;
                break;
              }

              _context.next = 13;
              return response.json();

            case 13:
              json = _context.sent;

              if (!(options !== null && options !== void 0 && options.responseHeaders)) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return", {
                data: json,
                headers: response.headers
              });

            case 16:
              return _context.abrupt("return", json);

            case 17:
              endTime = Date.now();
              requestTime = (endTime - startTime) / 1000;
              throw new Error("HTTP error ".concat(response.status, ": ").concat(response.statusText, "\nwhile trying to fetch: ").concat(fullUrl, "\nresponse returned after: ").concat(requestTime, " seconds\n      "));

            case 20:
              throw new Error("Client supports only absolute paths (starting with /)");

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _get.apply(this, arguments);
  }

  var retryGet = retry_retry(get, retryOptions);
  return {
    get: retryGet
  };
};



/***/ }),

/***/ 86708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D1": function() { return /* binding */ StaticSiteBackendProvider; },
/* harmony export */   "I4": function() { return /* binding */ createStaticSiteBackend; },
/* harmony export */   "gR": function() { return /* binding */ useStaticSiteBackend; }
/* harmony export */ });
/* unused harmony export StaticSiteBackendContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _segment_api_staticSiteBackend_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39896);


var StaticSiteBackendContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var StaticSiteBackendProvider = StaticSiteBackendContext.Provider;
var useStaticSiteBackend = function useStaticSiteBackend() {
  var staticSiteBackend = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(StaticSiteBackendContext);

  if (!staticSiteBackend) {
    throw new Error("Static site backend isn't available. Please set it via StaticSiteBackendProvider component.");
  }

  return staticSiteBackend;
}; // Helper method to simplify importing

var createStaticSiteBackend = function createStaticSiteBackend() {
  return (0,_segment_api_staticSiteBackend_client__WEBPACK_IMPORTED_MODULE_1__/* .createClient */ .e)();
};

/***/ }),

/***/ 33514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Dx; },
/* harmony export */   "Hq": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Hq; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Ob; },
/* harmony export */   "h4": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "uT": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "xv": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _FeatureBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13379);

_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .FeatureBox.displayName */ .Ob.displayName = "FeatureBoxBase";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Body.displayName */ .uT.displayName = "FeatureBox.Body";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Header.displayName */ .h4.displayName = "FeatureBox.Header";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Text.displayName */ .xv.displayName = "FeatureBox.Text";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Title.displayName */ .Dx.displayName = "FeatureBox.Title";


/***/ }),

/***/ 79600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ components_IconWrapper_IconWrapper; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/IconWrapper.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var IconWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1bo4d8j1"
} : 0)("width:44px;height:44px;border-radius:50%;color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";background-color:", function (_ref3) {
  var backgroundColor = _ref3.backgroundColor;
  return backgroundColor;
}, ";", function (_ref4) {
  var elevation = _ref4.elevation,
      theme = _ref4.theme;
  return elevation &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("box-shadow:", theme.shadows[elevation], ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));

var _ref =  true ? {
  name: "1iixa1j",
  styles: "width:40px;height:40px;svg{width:40px;height:40px;}padding:2px"
} : 0;

var Icon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1bo4d8j0"
} : 0)("display:block;width:24px;height:24px;padding:10px;", function (_ref5) {
  var variant = _ref5.variant;
  return variant === "transparent" && _ref;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/IconWrapper.tsx


var _excluded = ["tokens", "variant", "elevation", "className", "tag", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseIconWrapper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      variant = _ref.variant,
      elevation = _ref.elevation,
      className = _ref.className,
      tag = _ref.tag,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    className: className,
    elevation: elevation,
    as: tag
  }, tokens), rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
      variant: variant,
      children: children
    })
  }));
});

var getBackgroundPropTokens = function getBackgroundPropTokens(background, theme) {
  switch (background) {
    case "white":
      return {
        backgroundColor: theme.palette.neutrals.white[100],
        color: theme.palette.brand.boysenberry[500]
      };

    case "light":
      return {
        backgroundColor: theme.palette.brand.boysenberry[100],
        color: theme.palette.brand.darkAcai[700]
      };

    case "dark":
      return {
        backgroundColor: theme.palette.brand.darkAcai[600],
        color: theme.palette.brand.boysenberry[200]
      };

    default:
      return {
        backgroundColor: theme.palette.neutrals.white[100],
        color: theme.palette.twilio.gray[100]
      };
  }
};

var IconWrapper_IconWrapper = (0,useDesignTokens/* withDesignTokens */.Y)(BaseIconWrapper, function (_ref2) {
  var elevation = _ref2.elevation;
  return {
    elevation: elevation
  };
}, {
  light: function light(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.brand.darkAcai[700],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.brand.darkAcai[700],
      backgroundColor: theme.palette.brand.boysenberry[100]
    };
  },
  dark: function dark(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.neutrals.white[100],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.brand.boysenberry[200],
      backgroundColor: theme.palette.brand.darkAcai[600]
    };
  },
  twilioLight: function twilioLight(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.twilio.gray[100],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.twilio.gray[100],
      backgroundColor: theme.palette.neutrals.white[100]
    };
  }
});
/* harmony default export */ var components_IconWrapper_IconWrapper = (IconWrapper_IconWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/index.ts


/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 94932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* reexport */ useStartupLinks_useStartupLinks; }
});

// UNUSED EXPORTS: AIRTABLE_PARTNER_LINK, TYPEFORM_APPLY_LINK

// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ../../libs/utils/useStartupLinks/useStartupLinks.ts

var TYPEFORM_APPLY_LINK = "https://segment.typeform.com/to/S6MSYuLt/";
var AIRTABLE_PARTNER_LINK = "https://airtable.com/shr84MIvVo4k8xbaO?prefill_Segment%20Code=Ad-Landing-Page&hide_Segment%20Code=true";

var useStartupLinks = function useStartupLinks() {
  var router = (0,next_router.useRouter)(); // Get the current route's query string

  var queryString = Object.keys(router.query).map(function (key) {
    return "".concat(key, "=").concat(router.query[key]);
  }).join("&");
  return {
    applyLink: queryString ? "".concat(TYPEFORM_APPLY_LINK, "?").concat(queryString) : TYPEFORM_APPLY_LINK,
    partnerLink: queryString ? "".concat(AIRTABLE_PARTNER_LINK, "&").concat(queryString) : AIRTABLE_PARTNER_LINK
  };
};

/* harmony default export */ var useStartupLinks_useStartupLinks = (useStartupLinks);
;// CONCATENATED MODULE: ../../libs/utils/useStartupLinks/index.ts


/***/ }),

/***/ 10792:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry/startups",
      function () {
        return __webpack_require__(48824);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71494:
/***/ (function(module) {

module.exports = "/_next/static/images/OgIndustryStartups-bf9283ebb30171d1506502b34f2922e2.png";

/***/ }),

/***/ 37135:
/***/ (function(module) {

module.exports = "/_next/static/images/Cover-0a6ff5451432ee0c2e610a66ffafe583.png";

/***/ }),

/***/ 67399:
/***/ (function(module) {

module.exports = "/_next/static/images/HeroIndustryStartups@2x-324bfbc232947c29fc627e0750c8a033.png";

/***/ }),

/***/ 10345:
/***/ (function(module) {

module.exports = "/_next/static/images/LetEngineersFocused@2x-e9acf326551fbbc306d32aa7ee55aa3d.png";

/***/ }),

/***/ 19088:
/***/ (function(module) {

module.exports = "/_next/static/images/OneApi@2x-b91d84f35596949d2687727ba180f4b6.png";

/***/ }),

/***/ 52766:
/***/ (function(module) {

module.exports = "/_next/static/images/HeroIndustryStartups-75bdbe9cc5920e91e835a804ede13cd7.webp";

/***/ }),

/***/ 27573:
/***/ (function(module) {

module.exports = "/_next/static/images/HeroIndustryStartups@2x-aefd9d7aef00a8cbba24c278ace4add0.webp";

/***/ }),

/***/ 78682:
/***/ (function(module) {

module.exports = "/_next/static/images/HeroIndustryStartups@3x-1177dff42945951a959339a1145101c0.webp";

/***/ }),

/***/ 30149:
/***/ (function(module) {

module.exports = "/_next/static/images/LetEngineersFocused-34bd3a7a9f5d26ee89ecd11a9d55f92a.webp";

/***/ }),

/***/ 48702:
/***/ (function(module) {

module.exports = "/_next/static/images/LetEngineersFocused@2x-e9acf326551fbbc306d32aa7ee55aa3d.webp";

/***/ }),

/***/ 61950:
/***/ (function(module) {

module.exports = "/_next/static/images/LetEngineersFocused@3x-b8d234e2e69f715c88c657d32c007faf.webp";

/***/ }),

/***/ 47358:
/***/ (function(module) {

module.exports = "/_next/static/images/OneApi-d337e16bb75c12a9ded30309bc5352a6.webp";

/***/ }),

/***/ 65273:
/***/ (function(module) {

module.exports = "/_next/static/images/OneApi@2x-66f918e1d61b1f1e2f13c978a4272a98.webp";

/***/ }),

/***/ 97267:
/***/ (function(module) {

module.exports = "/_next/static/images/OneApi@3x-08870a645e110c1ae64b56ac59809930.webp";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,7209,1545,6234,4136,2073,6784,8392,5735,2429,2609,8187,3996,442,7079,4881,1385,3379,9550,814,8302,9774,2888,179], function() { return __webpack_exec__(10792); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);